// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2026 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

import assertNever from "assert-never";

import { State } from "~@jii/paths";

import { UsAzDateField } from "../UsAzSingleResidentContext/SingleResidentContextPresenter";

export type UsAzDateHash = ReturnType<typeof getInfoPageHashForDateKey>;

/**
 * Provides a link path that is relative to the resident's homepage
 */
export function linkToDateSection(dateKey: UsAzDateField): string {
  return `${State.Resident.$.UsAzMoreInformation.ImportantDates.buildRelativePath({})}#${getInfoPageHashForDateKey(dateKey)}`;
}

export function getInfoPageHashForDateKey(dateKey: UsAzDateField) {
  //  these headings have been explicitly added to the Markdown document
  // for this page. You need to ensure they remain in sync if anything changes!
  switch (dateKey) {
    case "tprDate":
    case "dtpDate":
    case "sedDate":
    case "csedDate":
      return dateKey;
    case "csbdDate":
    case "trToAddDate":
      return "csbdDate-trToAddDate";
    case "ercdDate":
    case "addDate":
      return "ercdDate-addDate";
    default:
      assertNever(dateKey);
  }
}
